import { Col, Row, Space, Typography } from 'antd'
import React from 'react'
import timeListImage from 'assets/images/images.png'
import style from './limitAndBlockCard.module.scss'
import { t } from 'i18next'
import LimitInfoRow from './limitInfoRow/LimitInfoRow'
import CardTypeInfo from '../cardTypeInfo/CardTypeInfo'

function CardInfoHeader({ data }:{data:any}) {
  const datas = [
    {
      title: t('businessCards.cardHolderName'),
      value: data?.generInfo.cardHolderFullName,
    },
    {
      title: t('businessCards.cardNumber'),
      value: data?.generInfo.pan,
    },
    {
      title: t('businessCards.expiryDate'),
      value: data?.generInfo.expDate,
    },
    {
      title: t('businessCards.cardCurrency'),
      value: data?.generInfo.accCurr,
    },
  ]

  return (
    <>
      <Row gutter={16} style={{ marginBottom: '24px' }}>
        <Col span={12}>
          <Row
            style={{ flexDirection: 'column', gap: 15 }}
            className={style['card-container']}
          >
            <Col span={24}>
              <CardTypeInfo
                cardType={data?.generInfo.paymSys}
                text={data?.generInfo.name}
              />
            </Col>
            <Col span={24}>
              <LimitInfoRow data={datas} />
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row
            style={{ height: '100%', paddingLeft: 50 }}
            justify="space-between"
            align="middle"
            className={style['card-container']}
          >
            <img src={timeListImage} alt="" width={87} height={94} />
            <Space direction="vertical" align="end">
              <Space>
                <Typography.Text>
                  {t('businessCards.totalLimitBalance')}:
                </Typography.Text>
                <Typography.Text strong>
                  {data?.generInfo.totalLimit + ' AZN'}
                </Typography.Text>
              </Space>
              <Space>
                <Typography.Text>
                  {t('businessCards.totalLimitResidue')}:
                </Typography.Text>
                <Typography.Text strong>
                  {data?.generInfo.availableTotalLimit + ' AZN'}
                </Typography.Text>
              </Space>
            </Space>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default CardInfoHeader
